import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { COMMA, ENTER, I } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { MatStepperModule } from '@angular/material/stepper';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { LeaveRequest, LocationRequest, OnBoardRequest, RouteChangeRequest, SiftRequest, TimeRequest, AddressUpdateRequest, RouteRequest, RouteCancelRequest, AdhocRequest, RouteLocationChangeRequest } from 'src/app/modules/request/allrequest';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
declare const mapUtilityMapBox, Swal;

export const DATE_FORMAT = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD/MM/YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "DD/MM/YYYY",
      monthYearA11yLabel: "MMMM YYYY"
    }
  };
  
@Component({
    selector: 'app-edit-request',
    templateUrl: './edit-request.component.html',
    styleUrls: ['./edit-request.component.css'],
    providers: [
        {
          provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE]
        },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
        DatePipe
      ]
})

export class EditRequestComponent {

    requestID: any;
    typeOfRequest: string;
    paramReqType:string = '';
    public singleReqListLink = '/organization/transport-manager/request/list-request/';
    /* request form variables */
    requestForm: FormGroup;
    public matFormSize = '12px';
    public linearForm: boolean = true;
    public getReqType:any='';

    /* request form preview */
    public leaverequset = LeaveRequest;
    public shiftRequest = SiftRequest;
    public onBoardReq = OnBoardRequest;
    public timeRequest = TimeRequest;
    public locatioRequest = LocationRequest;
    public routeChangeRequset = RouteChangeRequest;
    public addressUpdate = AddressUpdateRequest;
    public routeRequest = RouteRequest;
    public adhocRequest = AdhocRequest;
    public routeCancelRequest = RouteCancelRequest;
    public routeLocationChangeRequest = RouteLocationChangeRequest;


    /* custom form field modal variables */
    public closeCustomForm: boolean = true;
    public modalName="Add More Fields";
    public formFieldEdit:boolean = false;
    public formFieldEditIndex = -1;
    public formFieldEditData = {};

    /* custom form field table variables */
    public customFieldTableData = [];

    /* preview form fields */
    public formPreviewFields:any = [];

    /* Request form data */
    editRequestData: any;

    /* Action chipInput variable */
    actions = [];
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    /* Dropdown options */
    fieldOptions = {
        whoCanReq: ['Employee', 'Driver'],
        reqTo: ['Employee', 'Driver', 'Vendor', 'Manager'],
        defaultReqTo: ['Employee', 'Driver', 'Vendor', 'Manager'],
        requestValue: [
            { value: 'custom_request', viewValue: 'Custom request' },
            { value: 'on_board_request', viewValue: 'On Board Request' },
            { value: 'location_request', viewValue: 'Location Request' },
            { value: 'route_change', viewValue: 'Route Change' },
            { value: 'route_location_change_request', viewValue: 'Route Location Change Request' },
            { value: 'time_change', viewValue: 'Time Change' },
            { value: 'shift_change', viewValue: 'Shift Change' },
            { value: 'leave_request', viewValue: 'Leave Request' },
            { value: 'address_update', viewValue: 'Address Update' },
            { value: 'route_request', viewValue: 'Route Request' },
            { value: 'route_cancel', viewValue: 'Route Cancel' },            
            { value: 'adhoc_request', viewValue: 'Adhoc Request' }],
    }
    /* Update variables */
    public updateValues:any = [];

    /* Drag and Drop table data */
    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.customFieldTableData, event.previousIndex, event.currentIndex);
    }

    /* Title bar list button variables */
    public listBtnName = 'Request List';

    //Booking Days
    public formFields:any=[];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private api: ApiService,
        private storage: StorageService,
        private formBuilder: FormBuilder,
        private swal: SweetAlert
    ) {
        this.route.paramMap.subscribe((params: any) => {
            this.requestID = params.params.ID;
            this.paramReqType = params.params.type;
            this.getReqType = params.params.type;
            this.listBtnName = this.paramReqType.split('-').join(' ') + ' List';
            this.typeOfRequest = params.params.type=='custom-request'?'customId':'id';
            this.singleReqListLink = this.singleReqListLink + params.params.type;
        });

    }

    minDate: Date;
    maxDate = new Date();
    startDateValues: any = new Date();

    isShowFrom = false;
    public cutOffPickupHideAndShow :any=''
    public cutOffDropHideAndShow :any=''

 
    submitted = false;

    editCustomRequestData: any;

    isCoustomRequest = false;

    dataSource: any;

    noFields: boolean = false;

    show: boolean;  //table show

    ngOnInit() {
        this.requestFormLoad();
        if (this.typeOfRequest == 'customId') { this.getCustomRequest(); }
        if (this.typeOfRequest == 'id') { this.getListRequest(); }
    }

    requestFormLoad() {
        this.requestForm = this.formBuilder.group({
            title: new FormControl('', Validators.required),
            // requestTo: new FormControl('', Validators.required),
            // whomToShow: new FormControl('',Validators.required),
            requestType: new FormControl('', Validators.required),
            note: new FormControl('',[Validators.required]),
            priority: new FormControl('',[Validators.required]),
            isActive: new FormControl(''),
            // newMenu: new FormControl(''),
            // cutOffPickup: new FormControl(''),
            // cutOffDrop:new FormControl(''),

            

        });

        

        if(this.getReqType=='route-cancel'){
            this.requestForm.addControl('bookingDays', new FormControl('', [Validators.required,Validators.pattern('^[2-5]*$')]));
        }else{
            this.requestForm.removeControl('bookingDays');
        }

        if(['route-request','adhoc-request'].includes(this.getReqType)){            
            this.requestForm.addControl('bookingDays', new FormControl(2, [Validators.required]));
        }

        if(this.typeOfRequest == 'customId'){
            this.requestForm.addControl('action', new FormControl('', Validators.required));
            this.requestForm.addControl('startDate', new FormControl('', Validators.required));
            this.requestForm.addControl('endDate', new FormControl(''));
        }
    }
    getCustomRequest() {
        this.isShowFrom = false;
        let reqType = this.paramReqType.split('-').join('_');
        const obj = {
            orgID: this.storage.get('userInfo').orgID,
            requestID: this.requestID,
            requestType:[reqType],
        };
        this.api.ListRequest(obj).then((res: any) => {
            this.editCustomRequestData = res.data[reqType][0];
            this.isCoustomRequest = true;
            this.requestForm.patchValue(this.editCustomRequestData);
            this.requestForm.patchValue({ startDate: new Date(this.editCustomRequestData.startDate)});
            if(this.editCustomRequestData.endDate) this.requestForm.patchValue({endDate: new Date(this.editCustomRequestData.endDate)});
            this.startDateValues = this.editCustomRequestData.startDate;
            this.minDate = new Date(this.editCustomRequestData.startDate);
            this.requestToValue({ value: this.editCustomRequestData.whomToShow });
            setTimeout(() => {
                this.show = true;
            }, 300);
            this.actions = this.editCustomRequestData.action;
            if (this.editCustomRequestData['formFields'] && this.editCustomRequestData['formFields'].length > 0) {
                this.customFieldTableData = this.editCustomRequestData.formFields;
                this.formPreviewFields = this.customFieldTableData;
                this.isShowFrom = true;
                if (this.noFields) this.noFields = false;
            } else {
                this.noFields = true;
            }
            this.requstTypeValue(this.editCustomRequestData.requestType);
        }).catch((err) => {
            console.log(err);
        });
    }
    getListRequest() {
        const obj = {
            orgID: this.storage.get('userInfo').orgID,
            requestID: this.requestID
        };
        this.api.ListRequest(obj).then((res: any) => {
            let reqType = this.paramReqType.split('-').join('_');
            this.editRequestData = res.data[reqType][0];

            this.requestForm.patchValue(this.editRequestData);
            this.formFields=this.editRequestData['formFields'];
            let bookingDaysArr=this.editRequestData['formFields'].filter(e=>e.bookingDays);
            let bookingDays=bookingDaysArr[0]['bookingDays'];
            this.requestForm.patchValue({ bookingDays: bookingDays});
            this.requestToValue({ value: this.editRequestData.whomToShow });
            this.isShowFrom = true;
            this.requstTypeValue(this.editRequestData.requestType);
        }).catch((err) => {
            console.log(err);
        });
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        // Add our action list
        if ((value || '').trim()){
            this.actions.push({ name: value.trim() });
            this.requestForm.controls.action.patchValue(this.actions);
            this.fieldChange(this.actions,'chipInput','action');
        }
        // Reset the input value
        if (input) input.value = '';
    }

    remove(val): void {
        const index = this.actions.indexOf(val);
        if (index >= 0){
            this.actions.splice(index, 1);
            this.requestForm.controls.action.patchValue(this.actions);
            this.fieldChange(this.actions,'chipInput','action');
        }
    }

    requstTypeValue(val?) {
        switch (val) {
            case 'location_request': this.formPreviewFields = this.locatioRequest; break;
            case 'time_change': this.formPreviewFields = this.timeRequest; break;
            case 'route_change': this.formPreviewFields = this.routeChangeRequset; break;
            case 'shift_change': this.formPreviewFields = this.shiftRequest; break;
            case 'leave_request': this.formPreviewFields = this.leaverequset; break;
            case 'on_board_request': this.formPreviewFields = this.onBoardReq; break;
            case 'address_update': this.formPreviewFields = this.addressUpdate; break;
            case 'route_request': this.formPreviewFields = this.routeRequest; break;
            case 'route_cancel': this.formPreviewFields = this.routeCancelRequest; break;
            case 'adhoc_request': this.formPreviewFields = this.adhocRequest; break;
            case 'route_location_change_request': this.formPreviewFields = this.routeLocationChangeRequest; break;
            default:
            // this.isLocationDiv = false
        }
        this.formLoadPreview();
    }

    // who can request field changes

    requestToValue(event) {
        let newReqsto = [];
        newReqsto = this.fieldOptions.defaultReqTo.filter(function (val) {
            const newVar = event.value.indexOf(val) == -1;
            const newVa2 = event.value.indexOf(val) != -1;
            if (newVar) {
                return newVar;
            } else {
                newReqsto.push(val);
            }
            return newVar;
        });
        this.fieldOptions.reqTo = newReqsto;
        if (this.fieldOptions.whoCanReq.length == 0 && (this.requestForm.controls['requestTo'].value.length > 0))
            this.requestForm.controls['requestTo'].patchValue('');
    }

    customFormFieldAdd() {
        this.modalName = 'Add More Fields';
        this.formFieldEdit  = false;
        this.formFieldEditIndex = -1;
        this.formFieldEditData = {};
        this.closeCustomForm = false;
    }
    customFormFieldEdit(data,index){
        this.modalName = 'Edit Field';
        this.formFieldEdit = true;
        this.formFieldEditIndex = index;
        this.formFieldEditData = data;
        this.closeCustomForm = false;
    }
    customFormFieldDelete(data,index){
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this field!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',//'#3085d6',
            //  cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.customFieldTableData.splice(index, 1);
                this.fieldChange(this.customFieldTableData,'fields','formFields');
                Swal.fire(
                    'Deleted!',
                    'field has been deleted.',
                    'success'
                );
            }
        });
    }
    // restrictOnlyOneNum(event: any) {
    //     if (!`${event.target.value}${event.key}`.match(/^[0-9]{1}$/)) {
    //         // block the input if result does not match
    //         event.preventDefault();
    //         event.stopPropagation();
    //         return false;
    //     }
    // }
    restrictOnlyOneNum(event: any, activeRequest: string) {
        if (['route-request','adhoc-request'].includes(activeRequest)) {
            const newValue = `${event.target.value}${event.key}`;
            // If the new value is greater than 30 or not a valid number between 1 and 30, block the input
            if (!newValue.match(/^(?:[1-9]|[12][0-9]|30)$/)) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        } else {
            if (!`${event.target.value}${event.key}`.match(/^[2-5]{1}$/)) {
                // Block the input if the result does not match (only 1 to 5 allowed)
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        }
    }

    formFieldResult(event) {
        this.show = false;
        this.noFields = false;
        if(!this.formFieldEdit){
            this.customFieldTableData.push(event);
        }else{
            this.customFieldTableData[this.formFieldEditIndex] = event;
        }
        setTimeout(()=>{ 
            this.show = true;
            this.fieldChange(this.customFieldTableData,'fields','formFields');
            this.formPreviewFields = this.customFieldTableData;
            this.formLoadPreview();  
        },100);
    }
    formLoadPreview() {
        this.isShowFrom = false;
        setTimeout(() => {
            this.isShowFrom = true;
        }, 200);
    }

    //update
  // update unique field
  public upDateBtn :boolean =true
  fieldChange(e: any, type, field) {
    this.upDateBtn=false
    let value: any;
    if (type == 'text' || type == 'textarea' || type == 'time') {
      value = e.target.value;
    }
    if (type == 'date') {
      value = new Date(e.value).getTime();
    }
    if (type == 'dropdown' || type == 'radio') {
        value = e.value;
        if(field=='requestType') this.requstTypeValue(e.value);
        if(field=='whomToShow') this.requestToValue(e);
        if(field=='isActive') value = parseInt(e.value);
    }
    if (type == 'chipInput' || type=='fields') {
      value = e;
    }
    if (type == 'cutOffPickup') {
        value = e.target.value;
    }
    if (type == 'cutOffDrop') {
        value = e.target.value;
    }
    if (field && (value != undefined)) this.updateField(field, value);
  }

  updateField(field, value) {
    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value, };
      this.updateValues = [
        ...filterUpdate,
        obj,
      ]
    }
    else {
      let obj = { field: field, value: value, };
      this.updateValues.push(obj);
    }
  }
  public getPickupCutOff:any='';
  public getDropCutOff:any='';
  showcutOffPickup(e:any){
    this.getPickupCutOff = e.checked
    this.cutOffPickupHideAndShow = e.checked;
}
showcutOffDrop(e:any){
    this.getDropCutOff  = e.checked;
    this.cutOffDropHideAndShow = e.checked;
}
  /* Invidual form field check */
  public checkError = (controlName: string, errorName: string) => {
    return this.requestForm.controls[controlName].hasError(errorName);
  }
  requestFormValidation(){
      this.submitted = true;
  }

    onSubmit() {

        this.submitted = true;
        if (this.requestForm.invalid) return;   // stop here if form is invalid
        const obj = {
            requestID: this.requestID,
        };
        if (this.updateValues.length > 0) {
            this.updateValues.filter((e) => { obj[e.field] = e.value; });
            if(this.getPickupCutOff == false){
                obj['cutOffPickup'] = null
            }
            if( this.getDropCutOff == false){
                obj['cutOffDrop'] = null
            }
            if(['route-request','adhoc-request','route-cance'].includes(this.getReqType)){
                let bookingDaysArr=this.updateValues.filter(e=>e.field=='bookingDays');
                if(bookingDaysArr.length>0){
                    let bookDayIndex=this.formFields.findIndex(e=>e.bookingDays);
                    this.formFields[bookDayIndex]['bookingDays']=this.requestForm.value.bookingDays;
                    obj['formFields']=this.formFields;
                }

            }
            if(this.typeOfRequest == 'id' || (this.typeOfRequest == 'customId' && this.customFieldTableData.length>0)) {
                this.api.UpdateRequest(obj).then((res: any) => {
                    if (res.status == 'success') {
                        this.swal.swalFunction(res.status, res.status, res.message, 2000);
                        this.router.navigate([this.singleReqListLink]);
                    }
                    if (res == 'failure') {
                        this.swal.swalFunction('error', res.status, res.message, 2000);
                    }
                }).catch((err) => {
                        console.log(err);
                    });
            }
        }
        
    }
}
